import React, { useState, useEffect } from 'react';
import {
    HStack,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    useDisclosure,
    Spinner,
    Card
} from '@chakra-ui/react';



import { fetchWrapper } from '../../helpers';
import Header from '../../components/Header';



function TemplateMessage({header}) {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const { onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
    const [isOpenEdit, setIsOpenEdit] = useState(false)

    const [list, setList] = useState([])
    const [loading, setLoading] = useState(false);
    let user = JSON.parse(localStorage.getItem('customer'))
    const meClose = () => {

        onClose();
    }

    useEffect(() => {
        loadList();
    }, [])

    const loadList = async () => {
        setLoading(true)
        const url = `${process.env.REACT_APP_API_URL}/template/msg-temp-type-ids`;
        const data = await fetchWrapper.get(url)
        setList(data.data);
        setLoading(false)
    }

    const meEdit = (rs) => {
        setIsOpenEdit(true);
        // setModalEditView(<Edit meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />)
    }

    const meCloseEdit = () => {

        setIsOpenEdit(false);

    }


    const styleTextWithVariables = (text) => {
        // Regex to match variables starting with $
        const regex = /\$[a-zA-Z_][a-zA-Z0-9_]*/g;
        return text.split(regex).reduce((acc, part, i, arr) => {
            // Find all matches
            const matches = text.match(regex) || [];
            acc.push(
                <span key={`text-${i}`}>
                    {part}
                </span>
            );
            if (matches[i]) {
                acc.push(
                    <span key={`var-${i}`} style={{ color: 'blue' }}>
                        {matches[i]}
                    </span>
                );
            }
            return acc;
        }, []);
    };
    return (
        <>
            <Header header={header}/>
            {loading &&
                <HStack width="100%" h="100vh" top="0" left="0" bg="rgba(204, 204, 204, 0.5)" position="absolute" zIndex="9999" justifyContent="center">
                    <Spinner
                        thickness='4px'
                        speed='0.65s'
                        emptyColor='gray.200'
                        color='blue.500'
                        size='xl'
                    />
                </HStack>
            }
            {/* <CustomModalLink
				showModalButtonText="Template Messages Edit"
				modalHeader="Template Messages Edit"
				isOpenEdit={isOpenEdit}
				onCloseEdit={meCloseEdit}
				onOpenEdit={onOpenEdit}

				modalBody={modalEditView}
			/> */}
            <Card className='card-style' style={{ margin: "20px 70px" }} shadow={'xl'}>
                <div className="setting_detail_section" style={{ padding: "20px" }}>
                    
                    {/* <HStack justifyContent="space-between">
					<Box>
						<h2 className="main_heading">Template Messages</h2>
					</Box>
					<Box>
						<CustomModal
							showModalButtonText="Add New Template Message"
							modalHeader="Add New Template Message"
							isOpen={isOpen}
							onClose={onClose}
							onOpen={onOpen}
							modalBody=<Create meClose={meClose} loadList={loadList} />
						/>
					</Box>
				</HStack> */}



                    <div className="table_section">
                        <TableContainer width="100%">
                            <Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
                                <Thead>
                                    <Tr>
                                        <Th width="15%">Template Name</Th>
                                        <Th width="40%">Message</Th> {/* Increased width for message column */}

                                        <Th width="5%"></Th>
                                    </Tr>
                                </Thead>

                                <Tbody fontSize="14px">
                                    {list.map((rs, index) => {
                                        return (
                                            <>
                                                <Tr>
                                                    <Td>{rs.name}</Td>
                                                    <Td sx={{
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                        minWidth: '400px',
                                                        maxWidth: '40%',
                                                        p: 4,
                                                        verticalAlign: 'top'
                                                    }}>{styleTextWithVariables(rs.message)}</Td>

                                                </Tr>
                                            </>
                                        )
                                    })}







                                </Tbody>


                            </Table>

                        </TableContainer>
                    </div>

                </div>
            </Card>
        </>
    )
}


export default TemplateMessage
